var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"avatar-wrapper"},[(_setup.props.gender == 'female')?[_c(_setup.InlineSvg,{attrs:{"src":require('./avatar/user01c.svg')}})]:_vm._e(),(_setup.props.gender == 'male')?[_c(_setup.InlineSvg,{attrs:{"src":require('./avatar/user02c.svg')}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }